import React from "react";
import FeedbackStatistics from "./FeedbackStatistics";
import WaitlistedUsers from "./WaitlistedUsers";

const FeedbackAndWaitlist = ({ insights }) => {
  if (!insights) return null;

  
  return (
    <>
      <div className="feedback-waitlist-card">
        <FeedbackStatistics
          total_questions={insights.totalQuestions}
          feedback_count={insights.feedBackCount}
        />
        <WaitlistedUsers waitlist={insights.waitList?.entries} />
      </div>
    </>
  );
};

export default FeedbackAndWaitlist;
